import httpClientService from '@/services/httpClientService';

export default {
	getAllUsers: () => httpClientService.Get('/ClientUserModule/api/User'),
	getByUserId: (id) =>
		httpClientService.Get('/ClientUserModule/api/User/' + id),
	insertUser: (param) =>
		httpClientService.Post('/ClientUserModule/api/User', param),
	updateUser: (param) =>
		httpClientService.Put(`/ClientUserModule/api/User/${param.Id}`, param),
	deleteUser: (id) =>
		httpClientService.Delete('/ClientUserModule/api/User/' + id),
	getPermissionGroups: () =>
		httpClientService.Get('/ClientUserModule/api/PermissionGroup'),
	getAllPermissions: () =>
		httpClientService.Get(
			'/ClientUserModule/api/PermissionPermissionGroup'
		),

	getAllProjects: () =>
		httpClientService.Get('/ClientUserModule/api/Project'),

	getAllUserProjectsPermissions: (userId, projectId) =>
		httpClientService.Get(
			'/ClientUserModule/api/UserProjectPermission/?userId=' +
				userId +
				'&projectId=' +
				projectId
		),

	postUserProjectPermissions: (userId, projectId, permissions) => {
		let data = {
			UserId: userId,
			ProjectId: projectId,
			Permissions: permissions,
		};
		return httpClientService.Post(
			'/ClientUserModule/api/UserProjectPermission',
			data
		);
	},

	deleteUserProjectPermission: (userId, projectId, permissions) => {
		let data = {
			UserId: userId,
			ProjectId: projectId,
			Permissions: permissions,
		};
		return httpClientService.Delete(
			'/ClientUserModule/api/UserProjectPermission',
			data
		);
	},
	getAllUserProjects: (userId) =>
		httpClientService.Get(
			'/ClientUserModule/api/UserProject?userId=' + userId
		),
	postUserProject: (userId, projects) => {
		let data = { UserId: userId, Projects: projects };
		return httpClientService.Post(
			'/ClientUserModule/api/UserProject',
			data
		);
	},
	deleteUserProject: (userId, projects) => {
		let data = { UserId: userId, Projects: projects };
		return httpClientService.Delete(
			'/ClientUserModule/api/UserProject',
			data
		);
	},
};
